import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center px-6 py-20 overflow-hidden" data-id="element-120">
      {/* Background image with overlay */}
      <div className="absolute inset-0" data-id="element-121">
        <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1920&q=80" alt="Team collaboration" className="w-full h-full object-cover" data-id="element-122" />
        <div className="absolute inset-0 bg-gradient-to-br from-white/95 via-slate-50/90 to-emerald-50/85" data-id="element-123"></div>
      </div>

      {/* Subtle decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-124">
        <div className="absolute top-20 right-20 w-96 h-96 bg-emerald-200/30 rounded-full blur-3xl" data-id="element-125"></div>
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-purple-200/20 rounded-full blur-3xl" data-id="element-126"></div>
      </div>

      <div className="relative max-w-5xl mx-auto text-center z-10" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="mb-8" data-id="element-128">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rbqnTT3WAHBizaFCFvc1JL/logo.png" alt="Enlaces Consultora" className="h-32 mx-auto mb-8" data-id="element-129" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-130">
          Donde el talento encuentra su lugar
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-xl md:text-2xl text-slate-700 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-131">
          Somos un equipo de Lic. en psicología especializadas en la selección
          de personal: reclutamos, acompañamos e incorporamos el mejor capital
          humano para tu empresa
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-132">
          <a href="#contacto" className="group inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-emerald-500 to-emerald-600 text-white font-semibold rounded-lg hover:shadow-xl hover:shadow-emerald-500/30 transition-all duration-300 hover:scale-105" data-id="element-133">
            Busco talento
            <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-134" />
          </a>

          <a href="#empleo" className="inline-flex items-center justify-center px-8 py-4 bg-white/90 backdrop-blur-sm text-slate-700 font-semibold rounded-lg border-2 border-slate-300 hover:border-emerald-500 hover:text-emerald-600 hover:bg-white transition-all duration-300" data-id="element-135">
            Busco empleo
          </a>
        </motion.div>
      </div>
    </section>;
}